/**
 * fn：执行函数
 * wait：延迟执行时间
 * immediate：是否立即执行
 **/

export function debounce(fn, wait, immediate) {
  var timeout, result;
  var debounced = function () {
    var context = this;
    var args = arguments;
    clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait);
      if (callNow) result = fn.apply(context, args);
    } else {
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    }
    return result;
  };
  debounced.cancel = function () {
    clearTimeout(timeout);
    timeout = null;
  };
  return debounced;
}

/**
 * fn：执行函数
 * wait：延迟执行时间
 * immediate：是否立即执行
 **/
export function throttle(fn, wait, immediate) {
  let timeout;
  let previous = 0;
  var throttled = function () {
    let context = this;
    let args = arguments;
    if (immediate) {
      let now = Date.now();
      if (now - previous > wait) {
        fn.apply(context, args);
        previous = now;
      }
    } else {
      if (!timeout) {
        timeout = setTimeout(() => {
          timeout = null;
          fn.apply(context, args);
        }, wait);
      }
    }
  };
  throttled.cancel = function () {
    clearTimeout(timeout);
    previous = 0;
    timeout = null;
  };
  return throttled;
}

/**
 * @param {string} [type=''] 验证类型
 * @returns {object} 返回一个对象包含验证状态、错误信息、执行函数
 */
export function checkParam(type = "") {
  const param = type.toLowerCase();
  const regExp = {
    phone: /^[1][3,4,5,7,8,9]\d{9}$/,
    mail: /^([a-zA-Z\d_-])+@([a-zA-Z\d_-])+\.([a-zA-Z\d_-])+$/,
    idcard: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
  };
  const getErrorMessage = (value = "") => {
    const errorMessage = {
      phone: value ? "请输入正确格式的手机号" : "请输入您的手机号",
      mail: value ? "请输入正确格式的电子邮箱" : "请输入您的电子邮箱",
      idcard: value ? "请输入正确格式的身份证号" : "请输入您的身份证号",
    };
    return errorMessage[param];
  };
  return {
    status: false,
    message: "",
    execute: function (value = "") {
      if (regExp[param]) {
        this.status = regExp[param].test(value);
        this.message = this.status ? "" : getErrorMessage(value);
      } else {
        this.message = "验证参数错误";
      }
      return this;
    },
  };
}
